import { connect } from 'react-redux';
import SummaryCompare, {
  SummaryCompareProps,
} from '@/pages/CompanyReport/components/SummaryCompare';
import {
  getSummary,
  getFirst3Competitors,
} from '@/pages/CompanyReport/redux/selectors';

type StateProps = Omit<
  SummaryCompareProps,
  'handleAnchorUpdate' | 'sectionNumber' | 'onSectionChange'
>;
type ContainerProps = Partial<
  Pick<SummaryCompareProps, 'sectionNumber' | 'companyId'>
>;
//get the meta to know if customer total - current === 0
//get viewed company list to know if current company is not within the list
const mapStateToProps = (state, ownProps: ContainerProps): StateProps => {
  const { companyId } = ownProps;
  const summary = getSummary(state, ownProps);
  const competitors = getFirst3Competitors(state, ownProps);

  //determine if current company can be browsed by learner customer
  // const canViewCompany = canLearnerViewCompany(companyId as string)(state);

  return {
    isFund: summary.isFund,
    companyId: companyId as string,
    shortDescription: summary.shortDescription,
    description: summary.description,
    companyName: summary.shortName,
    tickerSymbol: summary.tickerSymbol,
    competitors,
    uniqueSymbol: summary.uniqueSymbol,
    snowflakePoints: summary.snowflakePoints,
    fundamentalsSentence: summary.fundamentals,
  };
};

export default connect(mapStateToProps)(SummaryCompare);
